import React from 'react'
import styles from './BuyCards.module.css'

const ItemBox = ({ icon, title, number, unit }) => {
  return (
    <div className={styles['item-wrapper']}>
      <div className={styles.top}>
        <img src={require(`../../../assets/images/buy_cards/icon${icon}.png`)} className={styles.icon} />
        <div className={styles['item-title']}>{title}</div>
      </div>
      <div className={styles.bottom}>
        {number}
        <span className={styles.unit}>{unit}</span>
      </div>
    </div>
  )
}

const PublicWelfareIntro = () => {
  return (
    <div className={styles['public-welfare']}>
      <div className={styles.title}>PADI 关注海洋保护</div>
      <div className={styles.content1}>
        <p className={styles['sub-title']}>污染正在侵蚀海洋，影响我们的生活…</p>
        <p className={styles.text}>每年约1000万吨塑料垃圾流入海洋，2045年，世界上74%的珊瑚将会白化。</p>
        <p className={styles.text}>
          全球海洋中的塑料数量将超过海洋中的鱼类，而每年吃海产品的人类可能会吃掉11.000件微塑料。
        </p>
      </div>
      <div className={styles['content-wrapper']}>
        <div className={styles.content2}>
          <div className={styles['content2-title']}>PADI 海洋公益经典项目</div>
          <div className={styles['sub-title']}>2021年打击海洋垃圾回顾</div>
          <div className={styles['sub-content-wrapper']}>
            <div className={styles['sub-content']}>
              <ItemBox icon={5} title={'全国点位'} number={23} unit={'个'} />
              <ItemBox icon={4} title={'参与人数'} number={1408} unit={'人'} />
            </div>
            <div className={styles['sub-content']}>
              <ItemBox icon={2} title={'活动天数'} number={239} unit={'天'} />
              <ItemBox icon={3} title={'活动天数'} number={4550} unit={'件'} />
            </div>
            <div className={styles['sub-content-last']}>
              <div className={styles.name}>
                <img src={require('../../../assets/images/buy_cards/icon1.png')} className={styles.icon} />
                <div className={styles['item-title']}>清理垃圾重量</div>
              </div>
              <div className={styles.weight}>
                1356<span className={styles.unit}>kg</span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.content3}>
          <div className={styles['img-top']}></div>
          <div className={styles.middle}>
            <div className={styles['middle-big-text']}>珊瑚保育</div>
            <div className={styles['middle-small-text']}>珊瑚种植</div>
          </div>
          <div className={styles['img-bottom']}></div>
        </div>
      </div>
      <div className={styles.content4}>
        <p>感谢你一直在关注海洋</p>
        <p>感谢你在寻求改变欢迎你加入海洋守</p>
        <p>护者队列一起探索奇遇，守护蔚蓝</p>
      </div>
    </div>
  )
}

export default PublicWelfareIntro
